import SettingLineAlert from "components/Profiles/SettingLineAlert";
import NotFooterLayout from "layouts/NotFooterLayout";
import React from "react";

const SettingLineAlertPage = () => {
  return (
    <>
      <NotFooterLayout namePage="ตั้งค่าแจ้งเตือนไลน์">
        <div className="layout-content">
            <SettingLineAlert />
        </div>
      </NotFooterLayout>
    </>
  );
};

export default SettingLineAlertPage;
